import CarouselHome from "../components/CarouselHome";
import DionisiacheHome from "../components/DionisiacheHome";
import NextShowCard from "../components/NextShowCard";
import OmbreSeraHome from "../components/OmbreSeraHome";

import classes from "./css/Home.module.css";

import next_mandragola from "../assets/next_mandragola.jpg";
import next_uno_nessuno from "../assets/next_uno_nessuno.jpg";

const HomePage = () => {
  return (
    <main>
      <div className={classes.header} alt="header">
        <div className={classes.header_title}>
          <span>NICASIO </span>
          <span>ANZELMO</span>
        </div>
      </div>

      <div className={classes.carousel}>
        <CarouselHome />
      </div>

      <div className={classes.next_shows}>
        <h3>Spettacoli in arrivo</h3>
        <div className={classes.next_shows_container}>
          <NextShowCard
            date={"2025"}
            title={"Mandragola"}
            author={"Niccolò Machiavelli"}
            image={next_mandragola}
            objectPosition={`top`}
          />
          <NextShowCard
            main_style={{ marginTop: "10em" }}
            info_style={{ backgroundColor: "#fe0865" }}
            date={"2025"}
            title={"Uno, Nessuno, Centomila"}
            author={"Luigi Pirandello"}
            image={next_uno_nessuno}
            objectPosition={`top`}
          />
        </div>
      </div>

      <div className={classes.dionisiache}>
        <OmbreSeraHome />
      </div>

      <div className={classes.dionisiache}>
        <DionisiacheHome />
      </div>
    </main>
  );
};

export default HomePage;
